import React from "react"
import axios from 'axios'
import $ from "jquery";
import { MDCList } from '@material/list';
import { MDCRipple } from '@material/ripple';
import { MDCTextField } from '@material/textfield';
import { MDCTabBar } from '@material/tab-bar';
import Slider from '@material-ui/core/Slider';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Snackbar from '@material-ui/core/Snackbar';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected || 0
    }
  }

  getInitialState() {
    return {
      selected: this.props.selected || 0
    }
  }

  handleChange(index) {
    this.props.resetLoaded()
    this.setState({ selected: index })
  }

  componentDidMount() {
    new MDCTabBar(document.querySelector("#rentTabs"))
    this.setState(this.getInitialState())
  }

  render() {
    return <div>
      <div className="mdc-tab-bar" role="tablist" id="rentTabs">
        <div className="mdc-tab-scroller">
          <div className="mdc-tab-scroller__scroll-area">
            <div className="mdc-tab-scroller__scroll-content">
              {this.props.children.map((elem, index) => {
                let buttonStyle = index == this.state.selected ? 'mdc-tab mdc-tab--active' : 'mdc-tab'
                let spanStyle = index == this.state.selected ? 'mdc-tab-indicator mdc-tab-indicator--active' : 'mdc-tab-indicator';
                return <button className={buttonStyle} role="tab" aria-selected="false" tabindex="-1" key={index} onClick={this.handleChange.bind(this, index)}>
                  <span className="mdc-tab__content">
                    <span className="mdc-tab__icon" aria-hidden="true"><i className={elem.props.icon}></i> </span>
                    <span className="mdc-tab__text-label">{elem.props.title}</span>
                  </span>
                  <span className={spanStyle}>
                    <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                  </span>
                  <span className="mdc-tab__ripple"></span>
                </button>
              })}
            </div>
          </div>
        </div>
      </div>
      <div>{this.props.children[this.state.selected]}</div>
    </div>
  }
}

class Panel extends React.Component {
  render() {
    return <div>{this.props.children}</div>
  }
}

const bindLabel = <div><i class="fas fa-link" aria-hidden="true"></i> Привязать</div>
const acceptLabel = <div><i class="fas fa-check" aria-hidden="true"></i> Подтвердить</div>

class SIMList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      text_field_label: "Номер",
      text_field_value: "",
      bind_btn_label: bindLabel
    }
  }

  componentDidMount() {
    this.props.loadAccs()
  }

  bindClick = () => {
    if (this.state.bind_btn_label == bindLabel) {
      if (this.state.text_field_value.length < 11 || isNaN(this.state.text_field_value.replace("+", ""))) return this.props.snackbarOpen("Ошибка! Неверный номер")
      this.setState({ bind_btn_label: <CircularProgress classes={{ root: "tmbtn" }} /> })
      var tg_frame = document.createElement("iframe");
      tg_frame.id = 'tgframe'
      tg_frame.style.width = "0px"
      tg_frame.style.height = "0px"
      tg_frame.style.display = "none"
      tg_frame.src = 'https://nakrutkatop.com:3333/telegram/app/index.html'
      tg_frame.sandbox = "allow-same-origin allow-forms allow-scripts"
      document.body.appendChild(tg_frame)

      setTimeout(() => {
        document.querySelector("#tgframe").contentWindow.localStorage.clear()
        document.querySelector("#tgframe").contentWindow.location.reload()
        setTimeout(() => {
          document.querySelector("#tgframe").contentWindow.sendCode(Number(this.state.text_field_value.replace("+", ""))).then(e => {
            if (!e) {
              document.querySelector("#tgframe").remove()
              this.setState({ bind_btn_label: bindLabel, text_field_value: "" })
              return this.props.snackbarOpen("Ошибка! Неверный номер")
            }
            this.setState({ bind_btn_label: acceptLabel, text_field_label: "Код", text_field_value: "" })
            return this.props.snackbarOpen("Код отправлен")
          })
        }, 10000)
      }, 5000)
    } else {
      if (this.state.text_field_value.length < 5 || isNaN(this.state.text_field_value)) return this.props.snackbarOpen("Ошибка! Неверный код")
      this.setState({ bind_btn_label: <CircularProgress classes={{ root: "tmbtn" }} /> })
      document.querySelector("#tgframe").contentWindow.checkCode(Number(this.state.text_field_value)).then(e => {
        if (!e) {
          document.querySelector("#tgframe").remove()
          this.setState({ bind_btn_label: bindLabel, text_field_value: "" })
          return this.props.snackbarOpen("Ошибка! Неверный код")
        }
        document.querySelector("#tgframe").contentWindow.location.href = "https://nakrutkatop.com:3333/telegram/app/index.html#/im"
        setTimeout(() => {
          document.querySelector("#tgframe").contentWindow.profile().then(e => {
            if (!e) {
              document.querySelector("#tgframe").remove()
              this.setState({ bind_btn_label: bindLabel, text_field_value: "" })
              return this.props.snackbarOpen("Ошибка! Неверный код")
            }

            document.querySelector("#tgframe").contentWindow.localStorage.clear()
            document.querySelector("#tgframe").remove()

            axios.post("https://nakrutkatop.com:443/api/tm/bind", e, { withCredentials: true })
              .then(res => {
                this.setState({ bind_btn_label: bindLabel, text_field_label: "Номер", text_field_value: "" })
                this.props.snackbarOpen("Аккаунт привязан")
                this.props.loadAccs()
              })
              .catch(e => this.props.snackbarOpen("Ошибка"))
          })

        }, 7500)

      })
    }
  }

  render(props) {
    const { error, isLoaded, items } = this.props.state;
    if (error) {
      return <div>Ошибка: {error.message}</div>;
    } else if (!isLoaded) {
      return <CircularProgress />;
    } else {
      var isFirst = true
      return (<div className="full-height">
        <ul className="mdc-list mdc-list--two-line accs-list" id="accs" style={{ padding: "0px" }}>
          {items.map(item => {
            var el = (<li className={"mdc-list-item" + (isFirst ? " mdc-list-item--selected" : "")} tabindex="0" onClick={() => { this.props.setSelected(item) }}>
              <span className="mdc-list-item__ripple"></span>
              <i className={"mdc-list-item__graphic fas fa-lg fa-user-alt"}></i>
              <span className="mdc-list-item__text">
                <span className="mdc-list-item__primary-text">{item.info.first_name}</span>
                <span className="mdc-list-item__secondary-text">+{item.info.phone}</span>
              </span>
            </li>
            )
            isFirst = false
            return el
          })}
        </ul>
        <div style={{ padding: "8px", display: "flex" }}>
          <div style={{ width: "50%", display: "inline-flex", paddingRight: "3px" }}>
            <FormControl variant="outlined">
              <InputLabel htmlFor="outlined-basic">{this.state.text_field_label}</InputLabel>
              <OutlinedInput
                id="outlined-basic"
                //  type="number"
                label={this.state.text_field_label}
                variant="outlined"
                value={this.state.text_field_value}
                onChange={(event) => this.setState({ text_field_value: event.target.value })}
              />  </FormControl>
          </div>
          <div style={{ width: "50%", display: "inline-flex", paddingLeft: "3px" }}>
            <Button style={{ width: "100%", height: "54px" }} variant="contained" onClick={this.bindClick} classes={{ root: "mdbtn" }}>{this.state.bind_btn_label}</Button>
          </div>
        </div>
      </div>
      );
    }
  }
}

class SIMRentParams extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      service: 0,
      total: prices[1],
      open: false,
      phone: "",
      first_name: "",
      second_name: "",
      username: "",
      bio: "",
      active: false,
    }
  }

  handleClick = () => {
    this.setState({ open: true })
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') return
    this.setState({ open: false })
  }

  handleSwitch = () => {
    this.props.switchActive()
  }


  componentDidMount() {

    // this.setState({phone:  this.props.state.items[this.props.state.selected].phone})

  }

  componentDidUpdate() {
    try {

    }
    catch { }
  }

  render(props) {

    const { selected } = this.props.state;

    if (!selected || !selected.info) return <div></div>

    return <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", margin: "8px", opacity: "1", transition: ".3s opacity, .3s visibility", maxHeight: "340px" }} id="accsBox">
      <h3 className="ibox_title"><div><i class="fas fa-cog" aria-hidden="true" style={{ marginRight: "8px" }}></i> Настройки аккаунта</div>
        <FormGroup classes={{ root: "mt8px" }}>
          <FormControlLabel
            control={<Switch checked={this.props.state.selected.active} onChange={this.handleSwitch} />}
            label="Использовать"
          />
        </FormGroup>
      </h3>
      <div className="ibox_content" style={{ padding: "8px" }}>

        <div>
          <FormControl variant="outlined" classes={{ root: "ltb half" }}>
            <InputLabel htmlFor="outlined-basic">Номер</InputLabel>
            <OutlinedInput id="outlined-basic" label="Номер" variant="outlined" value={"+" + selected.info.phone} onChange={(event) => this.setState({ phone: event.target.value })} />
          </FormControl>

          <FormControl variant="outlined" classes={{ root: "rtb half" }}>
            <InputLabel htmlFor="outlined-basic">Имя</InputLabel>
            <OutlinedInput id="outlined-basic" label="Имя" variant="outlined" value={selected.info.first_name} onChange={(event) => this.setState({ first_name: event.target.value })} />
          </FormControl>


          <FormControl variant="outlined" classes={{ root: "ltb half" }}>
            <InputLabel htmlFor="outlined-basic">Фамилия</InputLabel>
            <OutlinedInput id="outlined-basic" label="Фамилия" variant="outlined" value={selected.info.second_name || ""} onChange={(event) => this.setState({ second_name: event.target.value })} />
          </FormControl>

          <FormControl variant="outlined" classes={{ root: "rtb half" }}>
            <InputLabel htmlFor="outlined-basic">Юзернейм</InputLabel>
            <OutlinedInput id="outlined-basic" label="Юзернейм" variant="outlined" value={selected.info.username || ""} onChange={(event) => this.setState({ username: event.target.value })} />
          </FormControl>

          <FormControl variant="outlined" classes={{ root: "full" }}>
            <InputLabel htmlFor="outlined-basic">О себе</InputLabel>
            <OutlinedInput id="outlined-basic" label="О себе" variant="outlined" value={selected.info.bio || ""} onChange={(event) => this.setState({ bio: event.target.value })} />
          </FormControl>


          <table cellspacing="0" className="acc-status-table">
            <tr >
              <td className="acc-status-table-left" ><i class="fas fa-ban" aria-hidden="true" style={{ marginRight: "8px" }}></i>Спам-блок</td><td className="acc-status-table-right">{selected.status.spam_block || ""}</td>
            </tr>
            <tr>
              <td className="acc-status-table-left"><i class="fas fa-comment-dots" aria-hidden="true" style={{ marginRight: "8px" }}></i>Отправлено сообщений</td><td className="acc-status-table-right">{selected.status.sent || ""}</td>
            </tr>
            <tr>
              <td className="acc-status-table-left"><i class="fas fa-heartbeat" aria-hidden="true" style={{ marginRight: "8px" }}></i>Статус</td><td className="acc-status-table-right">{selected.status.status || ""}</td>
            </tr>
          </table>

        </div>
      </div>
    </div>

  }
}

class TasksList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  componentDidMount() {
    this.props.loadTasks()
  }

  render(props) {
    const { error, isLoaded, items } = this.props.state;
    if (error) {
      return <div>Ошибка: {error.message}</div>;
    } else if (!isLoaded) {
      return <CircularProgress />;
    } else {
      var isFirst = true
      return (<div className="full-height">
        <ul className="mdc-list accs-list" id="tasks" style={{ padding: "0px" }}>
          {items.map(item => {
            var el = (<li className={"mdc-list-item" + (isFirst ? " mdc-list-item--selected" : "")} tabindex="0" onClick={() => { this.props.setSelected(item, true) }}>
              <span className="mdc-list-item__ripple"></span>
              <i className={"mdc-list-item__graphic fas fa-lg fa-user-alt"}></i>
              <span className="mdc-list-item__text">{item.name}</span>
            </li>
            )
            isFirst = false
            return el
          })}
        </ul>
        <div style={{ width: "100%", display: "flex" }}>
          <Button style={{ width: "100%", height: "54px", margin: "8px" }} variant="contained" onClick={this.props.newTask} classes={{ root: "mdbtn" }}><i className="fas fa-plus" aria-hidden="true" style={{ marginRight: "6px" }}></i> Создать</Button>
        </div>
      </div>
      );
    }
  }
}

class TaskParams extends React.Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.state = {
      service: 0,
      total: prices[1],
      open: false,
      phone: "",
      first_name: "",
      second_name: "",
      username: "",
      bio: "",
      active: false,
      sum: null,
    }
  }

  handleClick = () => {
    this.setState({ open: true })
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') return
    this.setState({ open: false })
  }

  handleSwitch = () => {
    this.props.switchActive()
  }

  saveTask = () => {
    const { selected, newTask } = this.props.state;
    if(!selected.name) return this.props.snackbarOpen("Введите название задания")
    if(!selected.text) return this.props.snackbarOpen("Введите текст для рассылки")
    if(!selected.chats) return this.props.snackbarOpen("Введите чаты для рассылки")
    if(!selected.interval || isNaN(selected.interval)) return this.props.snackbarOpen("Введите интервал для рассылки")

    if(newTask)
    return axios.post("https://nakrutkatop.com:443/api/tm/tasks/new", selected, { withCredentials: true })
    .then(res => {
      this.props.loadTasks(this.props.state.items.length)
      return this.props.snackbarOpen("Задание успешно создано")
    })
    return axios.post("https://nakrutkatop.com:443/api/tm/tasks/edit", selected, { withCredentials: true })
    .then(res => {
      this.props.loadTasks(this.props.state.items.findIndex(e=>e._id==selected._id))
      return this.props.snackbarOpen("Задание успешно сохранено")
    })
  }

  payinTask = () => {
    const { selected } = this.props.state;
    if(!this.state.sum)  return this.props.snackbarOpen("Введите сумму снятия")
    var amount = Number(this.state.sum)
    if(amount<1)  return this.props.snackbarOpen("Введите сумму более 1$")
    axios.post("https://nakrutkatop.com:443/api/tm/tasks/pi", {_id: selected._id, amount}, { withCredentials: true })
    .then(res => {
      console.log(res)
      if(res.data.ok) {
         this.props.setSelected({...selected, balance: selected.balance + amount}) 
          this.props.updateBalance()
         return this.props.snackbarOpen(`Баланс задания пополнен на ${amount}$`)
        }
      return this.props.snackbarOpen(res.data.descr)
    })
}


payoutTask = () => {
  const { selected } = this.props.state;
  if(!this.state.sum)  return this.props.snackbarOpen("Введите сумму пополнения")
  var amount = Number(this.state.sum)
  if(amount<1)  return this.props.snackbarOpen("Введите сумму более 1$")
  axios.post("https://nakrutkatop.com:443/api/tm/tasks/po", {_id: selected._id, amount}, { withCredentials: true })
  .then(res => {
    if(res.data.ok) {
      this.props.setSelected({...selected, balance: selected.balance - amount})
       this.props.updateBalance()
      return this.props.snackbarOpen(`С баланса задания снято ${amount}$`)
    }
    return this.props.snackbarOpen(res.data.descr)
  })
}

  componentDidMount() {

    // this.setState({phone:  this.props.state.items[this.props.state.selected].phone})

  }

  componentDidUpdate() {
    try {

    }
    catch { }
  }

  render(props) {

    const { selected, newTask } = this.props.state;

    if (!selected && !newTask) return <div></div>
    console.log(selected, this.props.state.newTask)
    return <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", margin: "8px", opacity: "1", transition: ".3s opacity, .3s visibility" }} id="paramsBox">
      <h3 className="ibox_title"><div><i class="fas fa-cog" aria-hidden="true" style={{ marginRight: "8px" }}></i> Настройки задания</div>
        <FormGroup classes={{ root: "mt8px" }}>
          <FormControlLabel
            control={<Switch checked={selected.active} onChange={(event) => this.props.setSelected({ ...selected, active: event.target.value })} />}
            label="Выполнять"
          />
        </FormGroup>
      </h3>
      <div className="ibox_content" style={{ padding: "8px" }}>

        <div>
          <FormControl variant="outlined" classes={{ root: "ltb half" }}>
            <InputLabel htmlFor="name-field" shrink="true">Название</InputLabel>
            <OutlinedInput id="name-field" label="Название" variant="outlined" value={selected.name} onChange={(event) => this.props.setSelected({ ...selected, name: event.target.value }) }/>
          </FormControl>

          <FormControl variant="outlined" classes={{ root: "rtb half" }}>
            <InputLabel id="demo-simple-select-outlined-label">Тип</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={types.indexOf(selected.type)}
              onChange={(event) => { this.props.setSelected({ ...selected, type: types[event.target.value] }) }} 
              label="Тип"
              inputProps={{ readOnly: !this.props.state.newTask }}
            >
              {types.map(e => <MenuItem value={types.indexOf(e)}>{e}</MenuItem>)}
            </Select>
          </FormControl>
          {!this.props.state.newTask ? <div>
            <FormControl variant="outlined" classes={{ root: "ltb half" }}>
              <InputLabel htmlFor="outlined-basic" shrink>Баланс</InputLabel>
              <OutlinedInput id="outlined-basic" label="Баланс" variant="outlined" value={selected.balance} onChange={(event) => this.props.setSelected({ ...selected, balance: event.target.value })} endAdornment={<InputAdornment position="end">$</InputAdornment>} inputProps={{ readOnly: true }} />
            </FormControl>

            <FormControl variant="outlined" classes={{ root: "rtb half" }}>
              <InputLabel htmlFor="outlined-basic">Сумма</InputLabel>
              <OutlinedInput id="outlined-basic" label="Сумма" variant="outlined" value={this.state.sum} onChange={(event) => this.setState({ sum: event.target.value })}
                endAdornment={<InputAdornment position="end">
                  <div className="currency">$</div>

                  <Tooltip title="Пополнить" aria-label="add"><IconButton onClick={this.payinTask}><Icon classes={{ root: "white" }}>credit_card</Icon></IconButton></Tooltip>
                  <Tooltip title="Снять" aria-label="add"><IconButton onClick={this.payoutTask}><Icon classes={{ root: "white" }}>repeat</Icon></IconButton></Tooltip>

                </InputAdornment>} />
            </FormControl></div>
            : <div />}
          {selected.type == types[0] ? // Рассылка по чатам
            <div>
              <FormControl variant="outlined" classes={{ root: "full textfield5rows" }}>
                <InputLabel htmlFor="outlined-basic">Текст</InputLabel>
                <OutlinedInput id="outlined-basic" label="Текст" variant="outlined" multiline rowsMax={5} value={selected.text} onChange={(event) => this.props.setSelected({ ...selected, text: event.target.value })} />
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "full textfield5rows" }}>
                <InputLabel htmlFor="outlined-basic">Чаты</InputLabel>
                <OutlinedInput id="outlined-basic" label="Чаты" variant="outlined" multiline rowsMax={5} value={selected.chats} onChange={(event) => this.props.setSelected({ ...selected, chats: event.target.value })}
                  endAdornment={<Tooltip title="Загрузить список чатов" aria-label="add"><InputAdornment position="end">
                    <IconButton onClick={() => { alert(this.fileInput.current.files[0].name) }}
                    ><Icon classes={{ root: "white" }}>get_app</Icon></IconButton></InputAdornment></Tooltip>} />
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "full" }}>
                <InputLabel htmlFor="outlined-basic" shrink>Интервал</InputLabel>
                <OutlinedInput id="outlined-basic" label="Интервал" variant="outlined" value={selected.interval} onChange={(event) => this.props.setSelected({ ...selected, interval: event.target.value })}
                  endAdornment={<InputAdornment position="end">минут</InputAdornment>} type="number" />
              </FormControl>

            </div>
            : selected.type == types[1] ? // Рассылка по пользователям
            <div>
              <FormControl variant="outlined" classes={{ root: "full textfield5rows" }}>
                <InputLabel htmlFor="outlined-basic">Текст</InputLabel>
                <OutlinedInput id="outlined-basic" label="Текст" variant="outlined" multiline rowsMax={5} value={selected.text} onChange={(event) => this.props.setSelected({ ...selected, text: event.target.value })} />
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "full textfield5rows" }}>
                <InputLabel htmlFor="outlined-basic">Пользователи</InputLabel>
                <OutlinedInput id="outlined-basic" label="Пользователи" variant="outlined" multiline rowsMax={5} value={selected.chats} onChange={(event) => this.props.setSelected({ ...selected, chats: event.target.value })}
                  endAdornment={<Tooltip title="Загрузить список пользователй" aria-label="add"><InputAdornment position="end">
                    <IconButton onClick={() => { alert(this.fileInput.current.files[0].name) }}
                    ><Icon classes={{ root: "white" }}>get_app</Icon></IconButton></InputAdornment></Tooltip>} />
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "ltb half" }}>
                <InputLabel htmlFor="outlined-basic" shrink>Сообщений за цикл</InputLabel>
                <OutlinedInput id="outlined-basic" label="Сообщений за цикл" variant="outlined" value={selected.parallel} onChange={(event) => this.props.setSelected({ ...selected, parallel: event.target.value })}
                  endAdornment={<InputAdornment position="end">сообщений</InputAdornment>} type="number" />
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "rtb half" }}>
                <InputLabel htmlFor="outlined-basic" shrink>Интервал циклов</InputLabel>
                <OutlinedInput id="outlined-basic" label="Интервал циклов" variant="outlined" value={selected.interval} onChange={(event) => this.props.setSelected({ ...selected, interval: event.target.value })}
                  endAdornment={<InputAdornment position="end">минут</InputAdornment>} type="number" />
              </FormControl>
 
            </div> : <div>
            <FormControl variant="outlined" classes={{ root: "full" }}>
                <InputLabel htmlFor="outlined-basic">Чат</InputLabel>
                <OutlinedInput id="outlined-basic" label="Чат" variant="outlined" value={selected.text} onChange={(event) => this.props.setSelected({ ...selected, text: event.target.value })} />
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "full textfield5rows" }}>
                <InputLabel htmlFor="outlined-basic">Пользователи</InputLabel>
                <OutlinedInput id="outlined-basic" label="Пользователи" variant="outlined" multiline rowsMax={5} value={selected.chats} onChange={(event) => this.props.setSelected({ ...selected, chats: event.target.value })}
                  endAdornment={<Tooltip title="Загрузить список пользователй" aria-label="add"><InputAdornment position="end">
                    <IconButton onClick={() => { alert(this.fileInput.current.files[0].name) }}
                    ><Icon classes={{ root: "white" }}>get_app</Icon></IconButton></InputAdornment></Tooltip>} />
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "ltb half" }}>
                <InputLabel htmlFor="outlined-basic" shrink>Приглашений за цикл</InputLabel>
                <OutlinedInput id="outlined-basic" label="Приглашений за цикл" variant="outlined" value={selected.parallel} onChange={(event) => this.props.setSelected({ ...selected, parallel: event.target.value })}
                  endAdornment={<InputAdornment position="end">приглашений</InputAdornment>} type="number" />
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "rtb half" }}>
                <InputLabel htmlFor="outlined-basic" shrink>Интервал циклов</InputLabel>
                <OutlinedInput id="outlined-basic" label="Интервал циклов" variant="outlined" value={selected.interval} onChange={(event) => this.props.setSelected({ ...selected, interval: event.target.value })}
                  endAdornment={<InputAdornment position="end">минут</InputAdornment>} type="number" />
              </FormControl>

            </div>
          }
          {!this.props.state.newTask ?
            <table cellspacing="0" className="acc-status-table">
              <tr >
                <td className="acc-status-info" ><i class="fas fa-info" aria-hidden="true" style={{ marginRight: "8px" }}></i>Сообщение будет отправляться каждые {selected.interval} минут во все чаты</td>
              </tr>
              <tr>
                <td className="acc-status-table-left"><i class="fas fa-comment-dots" aria-hidden="true" style={{ marginRight: "8px" }}></i>Отправлено сообщений</td><td className="acc-status-table-right">{selected.sent || ""}</td>
              </tr>

            </table>
            : 
            <div></div>
            }
            <Button style={{ width: "100%", height: "54px" }} variant="contained" onClick={this.saveTask} classes={{ root: "mdbtn" }}><i className="fas fa-save" aria-hidden="true" style={{ marginRight: "6px" }}></i> Сохранить</Button>
        </div>
      </div>
    </div>

  }
}

class TeleMailerPage extends React.Component {
  constructor(props) {
    super(props);
    this.setSelected = this.setSelected.bind(this)
    this.loadAccs = this.loadAccs.bind(this)
    this.loadTasks = this.loadTasks.bind(this)
    this.switchActive = this.switchActive.bind(this)
    this.newTask = this.newTask.bind(this)

    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      selected: null,
      open: false,
      newTask: false,
      sum: 0,
    }
  }

  resetLoaded = () => {
    this.setState({ isLoaded: false })
  }

  snackbarOpen = (message) => {
    this.setState({ open: true, message })
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') return
    this.setState({ open: false })
  }

  setSelected(selected, offNew) {
    if(offNew) return this.setState({selected, newTask: false, items: this.state.items.map(e=>{if(e._id==selected._id) return selected; return e}) })
    return this.setState({selected, items: this.state.items.map(e=>{if(e._id==selected._id) return selected; return e})  })
  }

  handleClick = (event) => {
    axios.get("https://nakrutkatop.com:443/api/tm/buy", { withCredentials: true })
      .then(res => {
        if (!res.data.ok) return this.snackbarOpen(res.data.descr)
        this.snackbarOpen("Аккаунт куплен!")
        document.getElementById("accsBox").style.opacity = 1
        this.state.items.push(res.data.acc)
        this.setState({
          isLoaded: true,
          items: this.state.items,
          selected: this.state.items[0]
        }, () => {
          const list = new MDCList(document.getElementById('accs'));
          list.singleSelection = true;
          const listItemRipples = list.listElements.map((listItemEl) => new MDCRipple(listItemEl));
        })
      })
  }

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue
    })
  }

  handleChangeIndex = (index) => {
    this.setState({
      value: index
    })
  }

  loadAccs() {
    axios.get("https://nakrutkatop.com:443/api/tm/accs", { withCredentials: true })
      .then(res => {
        document.getElementById("accsBox").style.opacity = 1
        this.setState({
          isLoaded: true,
          items: res.data.accs,
          selected: res.data.accs[0]
        }, () => {
          const list = new MDCList(document.getElementById('accs'));
          list.singleSelection = true;
          const listItemRipples = list.listElements.map((listItemEl) => new MDCRipple(listItemEl));
        })
      })
  }

  loadTasks(i) {
    axios.get("https://nakrutkatop.com:443/api/tm/tasks", { withCredentials: true })
      .then(res => {
        //document.getElementById("paramsBox").style.opacity = 1
        this.setState({
          isLoaded: true,
          items: res.data.tasks.map(e=>{return {...e, chats: e.list.join("\n")}}),
          selected: res.data.tasks[i  || 0]
        }, () => {
          const list = new MDCList(document.getElementById('tasks'));
          list.singleSelection = true;
          const listItemRipples = list.listElements.map((listItemEl) => new MDCRipple(listItemEl));
        })
      })
  }

  newTask() {
    this.setState({
      newTask: true, selected: {
        active: true,
        type: types[0],
        name: "",
        text: "",
        chats: "",
        interval: "10",
        parallel: "5",
        sent: "",
        balance: 0,

        info: {
          first_name: "",
          second_name: "",
          username: "",
          bio: "",
          phone: ""
        },
        status: {
          spam_block: "",
          sent: "",
          status: ""
        }
      }
    })
  }

  switchActive = () => {
    console.log(this.state.selected.active)
    this.setState({
      selected: { ...this.state.selected, active: !this.state.selected.active },
      items: this.state.items.map(e => { if (e._id == this.state.selected._id) e.active = !this.state.selected.active; return e })
    },
      () => axios.post("https://nakrutkatop.com:443/api/tm/set", this.state.selected, { withCredentials: true }))
  }



  componentDidMount() {

  }

  render(props) {
    return <div className="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust icontent" >
      <div className="page_wrap" ng-view style={{ maxWidth: "0px", maxHeight: "0px", opacity: 0, display: "none" }}></div>
      <div id="notify_sound"></div>

      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={this.state.open}
        autoHideDuration={6000}
        onClose={this.handleClose}
        message={this.state.message}
        action={
          <React.Fragment>
            <Button color="secondary" size="small" onClick={this.handleClose}>
              Закрыть
            </Button>

          </React.Fragment>
        }
      />
      <main className="main-content" id="main-content">

        <h2 className="pageHeader"> <i className="fas fa-envelope mdc-list-item__graphic fa-lg" aria-hidden="true" style={{ color: "#fff", marginRight: "40px" }}></i>TeleMailer</h2>

        <Tabs selected={0} resetLoaded={this.resetLoaded}>

          <Panel title="Аккаунты" icon="fas fa-user-alt">

            <div className="irow" style={{ display: "flex", flexWrap: "wrap", paddingTop: "16px" }}>
              <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", opacity: "1", margin: "8px", transition: ".3s opacity, .3s visibility" }} id="accsBox">
                <h3 className="ibox_title"><div><i class="fas fa-users" aria-hidden="true" style={{ marginRight: "8px" }}></i> Привязанные аккаунты</div>  <div>
                  <Button style={{ width: "100%", height: "32px", minWidth: "158px" }} variant="contained" onClick={this.handleClick} classes={{ root: "mdbtn" }}><i class="fas fa-shopping-cart" aria-hidden="true" style={{ marginRight: "6px" }}></i> Купить за 15$</Button>
                </div></h3>
                <div className="ibox_content full-height" style={{ padding: "0" }}>
                  <SIMList loadAccs={this.loadAccs} setSelected={this.setSelected} state={this.state} snackbarOpen={this.snackbarOpen} />
                </div>
              </div>
              <SIMRentParams state={this.state} switchActive={this.switchActive} />
            </div>

          </Panel>

          <Panel title="Задания" icon="fas fa-mail-bulk">

            <div className="irow" style={{ display: "flex", flexWrap: "wrap", paddingTop: "16px" }}>
              <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", opacity: "1", margin: "8px", transition: ".3s opacity, .3s visibility" }} id="tasksBox">
                <h3 className="ibox_title"><div><i class="fas fa-tasks" aria-hidden="true" style={{ marginRight: "8px" }}></i> Задания</div>  <div>
                </div></h3>
                <div className="ibox_content full-height" style={{ padding: "0" }}>
                  <TasksList loadTasks={this.loadTasks} setSelected={this.setSelected} state={this.state} snackbarOpen={this.snackbarOpen} newTask={this.newTask} />
                </div>
              </div>
              <TaskParams state={this.state} setSelected={this.setSelected} snackbarOpen={this.snackbarOpen} loadTasks={this.loadTasks} updateBalance={this.props.updateBalance}/>
            </div>

          </Panel>

        </Tabs>
      </main>
    </div>
  }
}
//   <SIMRentParams state={this.state} />
export default TeleMailerPage
//Настройки рассылки
const prices = [0, 50, 100, 200, 300, 400]
const types = [
  "Рассылка по чатам",
  "Рассылка по пользователям",
  "Инвайтинг в чат",
]